module.exports = __webpack_public_path__ + "img/Union.f2340433.png";